import {Button, Flex, Icon, PriorityIcon, Title} from '@priority-software/priority-style-react';
import React from 'react';
import {isRTL} from '../../../../Localization';
import styles from './styles.module.scss';
import {createDataTestId} from '../../../../utils/dataTestId';

interface Props {
    items: string[];
    onClick: (index: number) => void;
}

const BreadCrumbs = ({items, onClick}: Props) => {
    const arrowIcon = <Icon icon={isRTL() ? PriorityIcon.arrowLeft : PriorityIcon.arrowRight} />;
    return (
        <Flex
            justifyContent="flex-start"
            {...createDataTestId('new-report-select-fields-breadcrumbs', true)}
        >
            {items.length === 1 && <Title skin="h6" textColor="secondary-500" text={items[0]} />}
            {items.length > 1 && (
                <>
                    <Title
                        componentClasses={styles.pointer}
                        onClick={() => onClick(0)}
                        skin="h6"
                        textColor="secondary-500"
                        text={items[0]}
                    />
                    {items.length > 2 && (
                        <>
                            {arrowIcon}
                            <Button skin="text" onClick={() => onClick(items.length - 2)}>
                                ...
                            </Button>
                        </>
                    )}
                    {arrowIcon}
                    <Title skin="h6" textColor="secondary-500" text={items[items.length - 1]} />
                </>
            )}
        </Flex>
    );
};

export default BreadCrumbs;
